var _path, _path2, _g, _path3, _g2, _g3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 44L27 44C27.5523 44 28 43.5523 28 43L28 38C28 37.4477 27.5523 37 27 37L12 37C11.4477 37 11 36.5523 11 36L11 21C11 20.4477 10.5523 20 10 20L5 20C4.44772 20 4 20.4477 4 21L4 43C4 43.5523 4.44772 44 5 44Z",
    fill: "#FF0400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 8L13 8C12.4477 8 12 8.44771 12 9L12 14C12 14.5523 12.4477 15 13 15L28 15C28.5523 15 29 15.4477 29 16L29 31C29 31.5523 29.4477 32 30 32L35 32C35.5523 32 36 31.5523 36 31L36 9C36 8.44772 35.5523 8 35 8Z",
    fill: "#FF0400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14307_39270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0711 18.9289C30.9464 17.0536 33.49 16 36.1421 16H52C54.2091 16 56 17.7909 56 20V56C56 58.2091 54.2091 60 52 60H24C21.7909 60 20 58.2091 20 56V32.1421C20 29.49 21.0536 26.9464 22.9289 25.0711L29.0711 18.9289Z",
    fill: "url(#paint0_linear_14307_39270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0711 18.9289C30.9464 17.0536 33.49 16 36.1421 16H52C54.2091 16 56 17.7909 56 20V56C56 58.2091 54.2091 60 52 60H24C21.7909 60 20 58.2091 20 56V32.1421C20 29.49 21.0536 26.9464 22.9289 25.0711L29.0711 18.9289Z",
    fill: "url(#paint1_radial_14307_39270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4246 19.2825C31.2062 17.5009 33.6226 16.5 36.1421 16.5H52C53.933 16.5 55.5 18.067 55.5 20V56C55.5 57.933 53.933 59.5 52 59.5H24C22.067 59.5 20.5 57.933 20.5 56V32.1421C20.5 29.6226 21.5009 27.2062 23.2825 25.4246L29.4246 19.2825Z",
    stroke: "url(#paint2_radial_14307_39270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4246 19.2825C31.2062 17.5009 33.6226 16.5 36.1421 16.5H52C53.933 16.5 55.5 18.067 55.5 20V56C55.5 57.933 53.933 59.5 52 59.5H24C22.067 59.5 20.5 57.933 20.5 56V32.1421C20.5 29.6226 21.5009 27.2062 23.2825 25.4246L29.4246 19.2825Z",
    stroke: "url(#paint3_radial_14307_39270)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4246 19.2825C31.2062 17.5009 33.6226 16.5 36.1421 16.5H52C53.933 16.5 55.5 18.067 55.5 20V56C55.5 57.933 53.933 59.5 52 59.5H24C22.067 59.5 20.5 57.933 20.5 56V32.1421C20.5 29.6226 21.5009 27.2062 23.2825 25.4246L29.4246 19.2825Z",
    stroke: "url(#paint4_radial_14307_39270)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32H21.5C21.2239 32 21 32.2239 21 32.5C21 32.7761 20.7761 33 20.5 33C20.2239 33 20 32.7761 20 32.5V31.9062C20 31.326 20.2305 30.7695 20.6408 30.3592L21.3284 29.6716C22.0786 28.9214 23.096 28.5 24.1569 28.5H27.5C30.2614 28.5 32.5 26.2614 32.5 23.5V19.3284C32.5 18.798 32.7107 18.2893 33.0858 17.9142L34.0389 16.9611C34.6543 16.3457 35.4889 16 36.3592 16H37.5C37.7761 16 38 16.2239 38 16.5C38 16.7761 37.7761 17 37.5 17H36C34.8954 17 34 17.8954 34 19V26C34 29.3137 31.3137 32 28 32Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14307_39270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1716 18.8284L22.9289 25.0711C21.0536 26.9464 20 29.49 20 32.1421V33C20.0281 30.2304 22.2813 28 25.051 28H28.5638C30.4616 28 32 26.4616 32 24.5638V20.0235C32 17.8105 33.7871 16.013 36 16C33.4388 16 30.9826 17.0174 29.1716 18.8284Z",
    fill: "url(#paint5_linear_14307_39270)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_14307_39270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 40L20.5 33.5L20.5206 31.4695C20.5373 29.8246 21.8755 28.5 23.5205 28.5H27.5C30.2614 28.5 32.5 26.2614 32.5 23.5V19.5059C32.5 17.8559 33.8325 16.5156 35.4824 16.506L36.5 16.5H42",
    stroke: "url(#paint6_radial_14307_39270)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41.4998L33.7071 38.207C33.3166 37.8164 32.6834 37.8164 32.2929 38.207L30.7338 39.7661C30.333 40.1669 30.3451 40.8203 30.7605 41.206L36.3094 46.3586C36.6973 46.7187 37.2986 46.7143 37.6811 46.3484L47.7612 36.7066C48.1665 36.3188 48.1737 35.6735 47.777 35.2769L46.2071 33.707C45.8166 33.3164 45.1834 33.3164 44.7929 33.707L37 41.4998Z",
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7071 37.2071L36 40.5L43.7929 32.7071C44.1834 32.3166 44.8166 32.3166 45.2071 32.7071L46.777 34.277C47.1737 34.6737 47.1665 35.319 46.7611 35.7068L36.6811 45.3486C36.2986 45.7144 35.6972 45.7189 35.3094 45.3587L29.7604 40.2061C29.3451 39.8204 29.333 39.167 29.7338 38.7662L31.2929 37.2071C31.6834 36.8166 32.3166 36.8166 32.7071 37.2071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14307_39270",
    x: 12,
    y: 8,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14307_39270",
    x: 12,
    y: 8,
    width: 32,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_14307_39270",
    x: 12,
    y: 8,
    width: 38,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14307_39270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14307_39270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14307_39270",
    x1: 20,
    y1: 16,
    x2: 45.6764,
    y2: 53.3475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14307_39270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 16) scale(32 44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_14307_39270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8889 44.7222) rotate(8.38061) scale(12.5788 17.1227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_14307_39270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7778 23.9444) rotate(126.027) scale(6.80074 28.5999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_14307_39270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.3333 24.5556) rotate(109.983) scale(19.5078 15.6632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14307_39270",
    x1: 26,
    y1: 22,
    x2: 33,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_14307_39270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5 27.5) rotate(135) scale(14.8492 13.3936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842374,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFormat);
export default __webpack_public_path__ + "static/media/file-format.db0be34e32712f440092ca4d120fe55e.svg";
export { ForwardRef as ReactComponent };